<template>
    <div class="list">
        <el-form :inline="true" size="small" :model="listQuery" class="demo-form-inline">
            <el-form-item>
                <el-input v-model="listQuery.keyword_search" clearable style="width: 300px" class="name-input" placeholder="请输入关键词" />
            </el-form-item>

            <el-form-item v-if="hasAdd" class="add">
                <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">筛选</el-button>
                <el-button type="primary" size="small" icon="el-icon-plus" @click="showDialog('add')">新建</el-button>
            </el-form-item>
        </el-form>

        <el-table v-loading="listLoading" :data="list" border style="width: 100%">
            <el-table-column prop="name" label="标题" align="center" />
            <el-table-column prop="dec" label="一句话描述" align="center" />
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button v-if="hasEdit" type="primary" size="mini" @click="showDialog('edit',scope)">编辑</el-button>
                    <el-button v-if="hasDelete" type="danger" size="mini" @click="handleDeleteClick(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page"><pagination v-show="total > 0" :total="total" :page.sync="listQuery.page_index" :limit.sync="listQuery.page_size" @pagination="getList" /></div>

        <common-dialog :title="dialogTitle" :dialog-visible="dialogVisible" :show-btns="showBtns">
            <el-form>
                <el-form-item label="分类名称" label-width="100px">
                    <el-input v-model="classInfo.name" placeholder="请输入分类名称"></el-input>
                </el-form-item>

                <el-form-item label="一句话描述" label-width="100px">
                    <el-input v-model="classInfo.dec" placeholder="请输入一句话描述"></el-input>
                </el-form-item>

                <el-form-item class="button_wrap">
                    <el-button type="primary" @click="dialogConfirmClick">保存</el-button>
                    <el-button @click="dialogVisible=false">取消</el-button>
                </el-form-item>
            </el-form>
        </common-dialog>
    </div>
</template>
<script>
import { getCaseClass, addCaseClass, deleteCaseClass, editCaseClass } from '@/api/case';
import Pagination from '@/components/Pagination';
import CommonDialog from '@/components/CommonDialog';
import operations from '../../mixins/operations';

export default {
    components: { Pagination, CommonDialog },
    mixins: [operations],
    data() {
        return {
            showBtns: false,
            dialogTitle: "",
            dialogType: "",
            list: [],
            dialogVisible: false,
            total: 0,
            listQuery: {
                page_index: 1,
                page_size: 10,
                keyword_search: ""
            },
            listLoading: false,
            classInfo: {
                name: "",
                dec: ""
            },
            id: ""
        };
    },
    computed: {
        hasAdd() {
            return this.operations.includes('新建案例分类');
        },
        hasEdit() {
            return this.operations.includes('编辑案例分类');
        },
        hasDelete() {
            return this.operations.includes('删除案例分类');
        }
    },
    async mounted() {
        this.getList();
    },
    methods: {
        async getList(params = this.listQuery) {
            this.listLoading = true;
            const { total, data } = await getCaseClass(params);
            this.listLoading = false;
            this.total = total;
            this.list = data;
        },

        showDialog(value, scope) {
            if (value == "edit") {
                this.dialogTitle = "编辑分类";
                this.id = scope.row.id;
                this.classInfo = Object.assign({}, scope.row);
            } else if (value == "add") {
                this.classInfo = {}
                this.dialogTitle = "新建分类"
            }
            this.dialogType = value;
            this.dialogVisible = true
        },

        async dialogConfirmClick() {
            const { name, dec } = this.classInfo;
            if (!name) return this.$notify.error({ title: '请输入分类名称' });
            if (!dec) return this.$notify.error({ title: '请输入描述' });
            if (this.dialogType == "add") {
                const res = await addCaseClass(this.classInfo);
                if (res == true) {
                    this.getList();
                    this.$notify({ title: '新增成功', type: 'success' });
                    this.dialogVisible = false;
                } else {
                    this.$notify.error({ title: '新增失败' });
                }
            } else if (this.dialogType == "edit") {
                const res = await editCaseClass(this.id, this.classInfo);
                if (res == true) {
                    this.getList();
                    this.$notify({ title: '编辑成功', type: 'success' });
                    this.dialogVisible = false;
                } else {
                    this.$notify.error({ title: '操作失败' });
                }
            }
        },

        handleDeleteClick(id) {
            this.$confirm(`是否删除该案例分类？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async() => {
                const res = await deleteCaseClass(id);
                if (res == true) {
                    this.getList();
                    this.$notify({ title: '删除成功', type: 'success' });
                    this.dialogVisible = false;
                } else {
                    this.$notify.error({ title: '操作失败' });
                }
            }).catch(() => {

            })
        }
    }
};
</script>

<style lang="less" scoped>
    .list{
        .el-menu-demo{
            margin-bottom: 20px;
        }
        .add{
            float: right;
            margin-bottom: 20px;
        }
        .button_wrap{
            text-align: center;
            margin-top: 30px;
        }
        .el-form-item:last-child{
            margin-bottom: 0;
        }
    }
</style>
